module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "menu  pos-rel m-t-20"
  }, [_vm._l((_vm.flows), function(flow, index) {
    return _c('div', {
      staticClass: "flow-menu",
      class: {
        'flow-menu-selected': flow.selected
      },
      on: {
        "click": function($event) {
          _vm.selectFlow(index)
        }
      }
    }, [_c('div', {
      staticClass: "icon-flow",
      class: flow.selected ? 'active-icon-' + flow.title : 'icon-' + flow.title
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(flow.name))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow",
    style: ({
      left: (114 + 238 * _vm.curFlowIndex) + "px"
    })
  })], true), _vm._v(" "), _c('div', {
    staticClass: "flow-cate bg-wh pos-rel p-l-10"
  }, [_c('ul', {
    staticClass: "m-t-20 p-t-30 p-b-10 m-r-110 p-r-10 m-b-0 p-l-0"
  }, [(_vm.curFlowTit == "addFlow") ? _c('li', {
    staticClass: "cate",
    class: {
      "cate-selected": _vm.all
    },
    on: {
      "click": function($event) {
        _vm.selectCate(-1, -1)
      }
    }
  }, [_vm._v("\n      全部\n      ")]) : _vm._e(), _vm._v(" "), (_vm.curFlowTit == "addFlow") ? _c('li', {
    staticClass: "cate",
    class: {
      "cate-selected": _vm.common
    },
    on: {
      "click": function($event) {
        _vm.selectCate(0, 0)
      }
    }
  }, [_vm._v("\n      常用流程\n      ")]) : _c('li', {
    staticClass: "cate",
    class: {
      "cate-selected": _vm.common
    },
    on: {
      "click": function($event) {
        _vm.selectCate(0, 0)
      }
    }
  }, [_vm._v("\n      全部\n      ")]), _vm._v(" "), _vm._v(" "), _vm._l((_vm.cates), function(cate, index) {
    return _c('li', {
      staticClass: "cate",
      class: {
        "cate-selected": _vm.cateId == cate.id
      },
      on: {
        "click": function($event) {
          _vm.selectCate(cate.id, index + 1)
        }
      }
    }, [_vm._v("\n      " + _vm._s(cate.name) + "\n      ")])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], true), _vm._v(" "), _c('div', {
    staticClass: "flod"
  }, [_c('div', {
    staticClass: "searchTip",
    on: {
      "click": _vm.searchContShow
    }
  }, [(_vm.searchShow) ? _c('span', [_vm._v("收起搜索")]) : _c('span', [_vm._v("展开搜索")]), _vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "jiantou",
    class: {
      "jiantouUp": _vm.searchShow, "jiantouDown": !_vm.searchShow
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bg-wh searchCont",
    class: {
      "hidden": !_vm.searchShow
    },
    staticStyle: {
      "padding-left": "54px"
    }
  }, [(_vm.curFlowTit == "addFlow") ? _c('div', {
    staticClass: "fl w-300 p-l-10",
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.search()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curKeywords),
      expression: "curKeywords"
    }],
    staticClass: "p-l-20 h-30",
    attrs: {
      "placeholder": "输入流程名称搜索"
    },
    domProps: {
      "value": _vm._s(_vm.curKeywords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.curKeywords = $event.target.value
      }
    }
  })]) : _c('div', {
    staticClass: "fl w-300",
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.search()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curKeywords),
      expression: "curKeywords"
    }],
    staticClass: "p-l-20 h-30",
    attrs: {
      "placeholder": "输入主题/申请人/编号 搜索"
    },
    domProps: {
      "value": _vm._s(_vm.curKeywords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.curKeywords = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._v(" "), (_vm.curFlowTit != "addFlow") ? _c('div', {
    staticClass: "fl m-l-10 p-l-10"
  }, [_c('daterange-filter', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curTimeRange),
      expression: "curTimeRange"
    }],
    attrs: {
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.curTimeRange)
    },
    on: {
      "input": function($event) {
        _vm.curTimeRange = $event
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fl m-l-20 p-l-10"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c8844cb0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flow/instance/topMenu.vue
// module id = 1989
// module chunks = 2